import { render, staticRenderFns } from "./ProfileRule.vue?vue&type=template&id=21b92487&"
import script from "./ProfileRule.vue?vue&type=script&lang=js&"
export * from "./ProfileRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports